import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Market } from '../models/market.model';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class MarketSelectionService {
  private readonly router = inject(Router);
  private readonly storageKey = 'rtm-cpm-market';

  private getInitialMarket(): Market {
    const raw = sessionStorage.getItem(this.storageKey);
    return raw ? JSON.parse(raw) as Market : new Market(0, 'MARKETS', '', false);
  }

  private readonly selectedMarketSubject = new BehaviorSubject<Market>(this.getInitialMarket());
  readonly selectedMarket$: Observable<Market> = this.selectedMarketSubject.asObservable();

  updateSelectedMarket(market: Market) {
    this.setSelectedMarket(market);
  }

  getSelectedMarket(): Market {
    return this.selectedMarketSubject.getValue();
  }

  onChangeMarket(url: string) {
    void this.router.navigate([url]);
  }

  setSelectedMarket(market: Market): void {
    const current = this.selectedMarketSubject.getValue();
    if (current?.id === market?.id) return;
    this.selectedMarketSubject.next(market);
    sessionStorage.setItem(this.storageKey, JSON.stringify(market));
    localStorage.setItem(this.storageKey, JSON.stringify(market));
    this.selectedMarketSubject.next(market);
  }

}